// 🔎 CLASSIFICADOR DE ERRO DA ASSINATURA — B332 (AI_149)
// ─────────────────────────────────────────────────────────────
// Decide O QUE o ModalAssinatura faz quando uma assinatura com a sessão
// REAPROVEITADA do cofre (B295) falha. Antes do B332, QUALQUER erro apagava o
// cofre e pedia o QR do BIRD ID de novo — visto ao vivo em 28/07: um 409 de
// corrida (requestId herdado na fila do caso misto) e os 500 transitórios da
// BRy destruíam uma sessão de 12h perfeitamente válida.
//
// Classes:
//   "sessao-expirada" → a BRy disse que a sessão morreu (401 → dica do
//                       assinar.js). Aí SIM: limpar o cofre + refazer com QR.
//   "em-andamento"    → HTTP 409 (já existe chamada em curso com o MESMO
//                       requestId). Aguardar e re-tentar com o MESMO id — se a
//                       outra chamada concluiu, o servidor devolve o CMS pronto
//                       (replay, sem gastar crédito novo).
//   "outra"           → transitório/indeterminado (BRy 5xx, rede, etc.).
//                       Mostrar o erro SEM descartar o cofre; o médico decide
//                       ("Tentar de novo" reusa a sessão / "Reautorizar" gera QR).
//
// ⚠️ CONTRATO com o backend: a detecção de "sessao-expirada" depende da frase
// da dica em api/assinar.js ("a sessão pode ter expirado — gere um novo link").
// Se a frase mudar lá, atualizar aqui junto.
// Nota: um HTTP 401 CRU de /api/assinar é a sessão do APP (Firebase), não a da
// BRy — limpar o cofre não ajudaria; fica em "outra" de propósito.
// ─────────────────────────────────────────────────────────────

export type ClasseErroAssinatura = "em-andamento" | "sessao-expirada" | "outra";

export function classificarErroAssinatura(mensagem: string | undefined): ClasseErroAssinatura {
  const m = (mensagem || "")
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, ""); // acento-insensível ("sessão" × "sessao")
  if (m.includes("http 409")) return "em-andamento";
  // B343 (AI_150) — a consulta de status passou a devolver 410 + "sessao_invalida"
  // quando a BRy recusa a sessão. Antes ela respondia 200/signatureReady:false e a
  // tela ficava no poll até os 15 min, reusando um cofre já morto a cada tentativa.
  if (m.includes("sessao_invalida") || m.includes("http 410")) {
    return "sessao-expirada";
  }
  if (m.includes("sessao pode ter expirado") || m.includes("gere um novo link")) {
    return "sessao-expirada";
  }
  return "outra";
}
